import { logUsage } from 'owa-analytics';
import {
    FileSelectionFilter,
    lazyAttachmentFilePicker,
    FilePickerAction,
    FileProvidersFilter,
} from 'owa-attachment-filepicker';
import EditorViewState from 'owa-editor/lib/store/schema/EditorViewState';
import { lazyInsertLinks } from 'owa-insert-link';
import { InsertLinksHost } from 'owa-attachment-link-common';
import loc from 'owa-localize';
import getSelectedData from 'owa-editor/lib/utils/getSelectedData';
import { confirm } from 'owa-confirm-dialog';
import {
    CouldNotInsertHyperLinkTitle,
    BrowseCloudLocationsHyperLink,
    BrowseCloudLocationsOnlyAllowOneFile,
} from './openFilePicker.locstring.json';
import { closeButtonLabel } from 'owa-locstrings/lib/strings/closebuttonlabel.locstring.json';

export const openFilePickerForInsertLinksHandler = async (
    insertLinkshost: InsertLinksHost,
    editorViewState: EditorViewState,
    targetWindow: Window,
    fromAddress: string
) => {
    logUsage('HyperlinkOpenFilePicker');
    const selectedData = getSelectedData(editorViewState);
    let selectionText: string;
    if (selectedData?.data) {
        if (selectedData.data.indexOf('<') === -1) {
            // User has selected pure text
            selectionText = selectedData.data;
        } else {
            // User has selected complex data which doesn't support insert link
            logUsage('HyperlinkUnsupportedContent');
            await confirm(
                loc(CouldNotInsertHyperLinkTitle),
                loc(BrowseCloudLocationsHyperLink),
                false,
                {
                    hideCancelButton: true,
                    okText: loc(closeButtonLabel),
                }
            );
            return;
        }
    }

    lazyAttachmentFilePicker.importAndExecute(
        null /* createAttachmentHandler */,
        async params => {
            // When user has selected some text, we only allow picking up one file
            if (selectionText && params.files.length > 1) {
                logUsage('HyperlinkMultipleFilesForText');
                await confirm(
                    loc(CouldNotInsertHyperLinkTitle),
                    loc(BrowseCloudLocationsOnlyAllowOneFile),
                    false,
                    {
                        hideCancelButton: true,
                        okText: loc(closeButtonLabel),
                    }
                );
                return;
            }
            const insertLinks = await lazyInsertLinks.import();
            insertLinks(
                params.files,
                insertLinkshost,
                editorViewState,
                fromAddress,
                targetWindow,
                selectionText
            );
        },
        {
            fileSelectionFilter: FileSelectionFilter.None,
            fileProvidersFilter: FileProvidersFilter.HyperlinkEntry,
            disableLocalComputerFilePicker: true,
            supportsInsertLink: true,
            forcedAction: FilePickerAction.InsertAsLink,
            targetWindow: targetWindow,
        }
    );
};
